import { render, staticRenderFns } from "./SalesCustomer.vue?vue&type=template&id=3a30946d&scoped=true&"
import script from "./SalesCustomer.vue?vue&type=script&lang=js&"
export * from "./SalesCustomer.vue?vue&type=script&lang=js&"
import style0 from "./SalesCustomer.vue?vue&type=style&index=0&id=3a30946d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a30946d",
  null
  
)

export default component.exports